import type { FaireProductEntity } from "../../entity_types/product";

export const p_2bwau32gtz: FaireProductEntity = {
  token: "p_2bwau32gtz",
  type: "product",
  name: "Raspberry Rhinestone Bow Baby Headband - Hair Accessories",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/a3c15182a1f416d86164121ccd74b46b5bd90d8bb3eb71ef58011ee8a02dbc87.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ff1a0b63a664e020f7b9f5aa719b5aef9015c9e3bead47f74fd89948515449b.jpeg",
    "https://cdn.faire.com/fastly/6c91718bdeca525a30cf3babd0f2edbb5ca96fa713a2d92b22c08ee3d98954dd.jpeg",
    "https://cdn.faire.com/fastly/36a2bc9dadc7efb5575b38566ae6ff5f07e5d099863605c1b8a792b4dc0d24d9.jpeg",
    "https://cdn.faire.com/fastly/ff441e16bbda291dc368e1b6ecb13168ce536b32912fba7e7f3d03bc211067ed.jpeg",
  ],
  priceDollars: 6,
  description:
    "Sweeten her first photos and everyday moments with this sparkly headband that brings a touch of magic to your tiniest star.\n\nFeatures:\n * Raspberry pink tulle bow with multicolor rhinestone accents \n * Nylon elastic hair band \n * Glitter accents are “shed free” \n * Recommended for babies 0-24 months \n\nPair this headband with a matching Sweet Wink tutu and shirt for a complete head-to-toe outfit!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:25.154Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
